"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PRC_LICENSE_NO_PATTERN () {
        return _identifiers.PRC_LICENSE_NO_PATTERN;
    },
    get PRESCRIBER_LIST_MAX_ITEMS () {
        return _prescriberprofile.PRESCRIBER_LIST_MAX_ITEMS;
    },
    get PRESCRIBER_NOT_A_DOCTOR () {
        return _prescribererrors.PRESCRIBER_NOT_A_DOCTOR;
    },
    get PRESCRIBER_PROFILE_LIMITS () {
        return _prescribersnapshot.PRESCRIBER_PROFILE_LIMITS;
    },
    get PRESCRIBER_PROFILE_VERSION_CONFLICT () {
        return _prescribererrors.PRESCRIBER_PROFILE_VERSION_CONFLICT;
    },
    get PRESCRIBER_REFERENCE_NO_PATTERN () {
        return _identifiers.PRESCRIBER_REFERENCE_NO_PATTERN;
    },
    get PRESCRIBER_SNAPSHOT_FIELDS () {
        return _prescribersnapshot.PRESCRIBER_SNAPSHOT_FIELDS;
    },
    get PrescriberListItemSchema () {
        return _prescriberprofile.PrescriberListItemSchema;
    },
    get PrescriberListResponseSchema () {
        return _prescriberprofile.PrescriberListResponseSchema;
    },
    get PrescriberProfileNotSetResponseSchema () {
        return _prescriberprofile.PrescriberProfileNotSetResponseSchema;
    },
    get PrescriberProfileResponseSchema () {
        return _prescriberprofile.PrescriberProfileResponseSchema;
    },
    get PrescriberProfileSaveResponseSchema () {
        return _prescriberprofile.PrescriberProfileSaveResponseSchema;
    },
    get PrescriberProfileSetResponseSchema () {
        return _prescriberprofile.PrescriberProfileSetResponseSchema;
    },
    get PrescriberProfileUpdateRequestSchema () {
        return _prescriberprofile.PrescriberProfileUpdateRequestSchema;
    },
    get PrescriberSnapshotSchema () {
        return _prescribersnapshot.PrescriberSnapshotSchema;
    },
    get normalizePrcLicenseNo () {
        return _identifiers.normalizePrcLicenseNo;
    },
    get normalizePrescriberReferenceNo () {
        return _identifiers.normalizePrescriberReferenceNo;
    }
});
const _identifiers = require("./identifiers");
const _prescribersnapshot = require("./prescriber-snapshot");
const _prescriberprofile = require("./prescriber-profile");
const _prescribererrors = require("./prescriber-errors");
